import type {
  ClientModTemplate,
  ClientModTemplateAssignment,
  ClientModTemplateDuplicate,
  ClientModTemplateInput,
  ClientTemplateStatus,
  ClientPackVerification,
  ClientTemplateVerification,
} from '@mcpanel/core';
import { rawRequest } from './client';
const path = '/client-mod-templates';
const serverPath = (id: string) => `/servers/${encodeURIComponent(id)}/client-mod-template`;
export const clientModsApi = {
  verification: (id: string) =>
    rawRequest<ClientPackVerification>('GET', `/servers/${encodeURIComponent(id)}/client-pack-verification`),
  retest: (id: string) =>
    rawRequest<ClientPackVerification>('POST', `/servers/${encodeURIComponent(id)}/client-pack-verification/retest`),
  verifications: (id: string) =>
    rawRequest<ClientTemplateVerification[]>('GET', `${path}/${encodeURIComponent(id)}/verifications`),
  list: () => rawRequest<ClientModTemplate[]>('GET', path),
  create: (input: ClientModTemplateInput) => rawRequest<ClientModTemplate>('POST', path, input),
  update: (id: string, input: ClientModTemplateInput) =>
    rawRequest<ClientModTemplate>('PUT', `${path}/${encodeURIComponent(id)}`, input),
  duplicate: (id: string, input: ClientModTemplateDuplicate) =>
    rawRequest<ClientModTemplate>('POST', `${path}/${encodeURIComponent(id)}/duplicate`, input),
  assign: (id: string, input: ClientModTemplateAssignment) =>
    rawRequest<ClientModTemplateAssignment>('PUT', `${path}/${encodeURIComponent(id)}/assignment`, input),
  delete: (id: string) => rawRequest<void>('DELETE', `${path}/${encodeURIComponent(id)}`),
  status: (id: string) => rawRequest<ClientTemplateStatus>('GET', serverPath(id)),
  select: (id: string, templateId: string | null) =>
    rawRequest<{ templateId: string | null }>('PUT', serverPath(id), { templateId }),
  /** 管理者用（パネルにログインしたランチャーだけが受け取る） */
  adminSelected: (id: string) =>
    rawRequest<{ templateId: string | null }>('GET', `/servers/${encodeURIComponent(id)}/admin-client-mod-template`),
  selectAdmin: (id: string, templateId: string | null) =>
    rawRequest<{ templateId: string | null }>('PUT', `/servers/${encodeURIComponent(id)}/admin-client-mod-template`, {
      templateId,
    }),
};
